export default {
	title: "Cartes de présence",
	cards: "Cartes de présence",
	newCard: "Nouvelle carte",
	editCard: "Modifier la carte",
	deleteCard: "Supprimer la carte",
	noCards: "Aucune carte configurée",
	noCardsDescription: "Ajoutez des cartes de présence pour configurer les types de service pour ce rituel",
	form: {
		hasQueueLabel: "Avec file d'attente",
		attendanceTypeLabel: "Type de présence",
		attendanceTypeHint: "Sélectionnez le type de présence à associer à ce rituel",
		maxTicketsOverrideLabel: "Limite de tickets (remplacement)",
		maxTicketsOverrideHint: "Laissez vide pour utiliser la valeur par défaut du type de présence",
		defaultMaxTickets: "Par défaut",
		typeInfo: "Configuration du type",
	},
	numberingModes: {
		INCREMENTAL: "À la demande",
		PRE_DEFINED: "Fixe",
		incrementalDescription: "Tickets ajoutés un par un, à la demande",
		preDefinedDescription: "Affiche tous les tickets de 1 à N en une fois",
	},
	messages: {
		created: "Carte de présence créée avec succès",
		updated: "Carte de présence mise à jour avec succès",
		deleted: "Carte de présence supprimée avec succès",
		deleteError: "Erreur lors de la suppression de la carte de présence",
		loadError: "Erreur lors du chargement des cartes de présence",
		copied: "Cartes de présence importées avec succès",
		copyError: "Erreur lors de l'importation des cartes de présence",
	},
	deleteConfirmation: "Êtes-vous sûr de vouloir supprimer la carte {label} ?",
	deleteWarning: "Cette action est irréversible.",
	copyFrom: "Importer des cartes",
	copyFromTitle: "Importer la structure des cartes",
	copyFromHint: "Sélectionnez un type de rituel pour copier ses liens de présence",
	copyFromPlaceholder: "Sélectionnez le type de rituel source",
	overridden: "Remplacé",
	validation: {
		maxTicketsMin: "La quantité minimale est 1",
		attendanceTypeRequired: "Le type de présence est requis",
	},
};
